import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=224a2c44&scoped=true&"
import script from "./FormContainer.vue?vue&type=script&lang=js&"
export * from "./FormContainer.vue?vue&type=script&lang=js&"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=224a2c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a2c44",
  null
  
)

export default component.exports